import React, { useEffect } from "react";
import { T } from "react-translator-component";
import { Modal, Box, Button, Stack } from "@mui/material";
import ButtonPrimary from "../../ButtonPrimary";

// Define the props interface
interface MessageModalProps {
  open: boolean;
  buttonText?:string;
  showButton?: boolean;
  message: string;
  onClose: () => void;
  onContinue?: () => void;
  buttonStyles?: any;
  alignLeft?: boolean;
}

const MessageModal: React.FC<MessageModalProps> = ({
  open,
  onClose,
  onContinue,
  buttonText,
  showButton,
  message,
  buttonStyles,
  alignLeft
}) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (open && !showButton) {
      // Close the modal after 3 seconds if showButton is false
      timer = setTimeout(() => {
        onClose();
      }, 2500);
    }

    return () => clearTimeout(timer); // Clear the timer if the component unmounts
  }, [open, showButton, onClose]);

  const splitText = (text: string) => {
    return text.split('\n')
  }

  const existSplitText = (text: string) => {
    const result = text.indexOf('\n')
    return result > 0 ? true : false
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: alignLeft ? "left" : "center",
          fontFamily: "mplus-1c-regular"
        }}
      >
        {existSplitText(message) ? (
          <>
            {splitText(message).map((text: string, index: number) => (
              <span key={`message_${index}`} style={{display: 'block'}}>{text}</span>
            ))}
          </>
        ) : (
          message
        )}

        {(showButton && onContinue) && (
          <>
            {buttonStyles ? (
              <Stack
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <Button
                  onClick={onClose}
                  style={ buttonStyles }
                  size={"large"}
                  variant="outlined"
                >
                  {buttonText ? buttonText : T('agree')}
                </Button>
              </Stack>
            ) : (
              <ButtonPrimary
                title={buttonText ? buttonText : T('agree')}
                onClick={onContinue}
              />
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default MessageModal;
